import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import './BlogIndexPage.css';

const BlogIndexPage = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                // Preverite, ali je REACT_APP_API_URL pravilno nastavljen v vašem .env okolju
                const response = await fetch(`${process.env.REACT_APP_API_URL}/blog/posts`);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                setPosts(data.posts || []);
            } catch (err) {
                setError('Prišlo je do napake pri nalaganju objav.');
            } finally {
                setLoading(false);
            }
        };
        fetchPosts();
    }, []);

    if (loading) {
        return (
            <div className="loading-spinner-container">
                <Spinner animation="border" />
            </div>
        );
    }

    if (error) {
        return (
            <Container className="error-alert-container">
                <Alert variant="danger">{error}</Alert>
            </Container>
        );
    }

    return (
        <div className="blog-index-page">
            <section className="hero-gradient">
                <header className="page-header text-center">
                    <h1 className="page-title">Naš Blog</h1>
                    <p className="page-subtitle">Zadnje objave, novice in zanimivosti iz našega sveta.</p>
                </header>
            </section>

            <Container className="my-5">
                <Row>
                    {posts.map(post => (
                        <Col md={6} lg={4} key={post.id} className="mb-4 d-flex justify-content-center">
                            <div className="blog-box">
                                <h3>
                                    <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                                </h3>
                                <p>{post.meta_description || 'Opis ni na voljo.'}</p>
                                <Link to={`/blog/${post.slug}`} className="blog-link">
                                    Preberi več →
                                </Link>
                                <div className="post-date">
                                    Objavljeno: {new Date(post.created_at).toLocaleDateString('sl-SI')}
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );
}

export default BlogIndexPage;